import { NavigationData } from '../types/navigation'

export const navigationData: NavigationData[] = [
  // حلول عملية موجّهة لغير التقنيين
  {
    id: 'solutions',
    name: 'حلول',
    url: '/solutions',
    hasDropdown: true,
    children: [
      { id: 'business-tools', name: 'أدوات الأعمال', url: '/catalog?category=business-tools' },
      { id: 'automation', name: 'الأتمتة وإدارة العمليات', url: '/catalog?category=automation' },
      { id: 'marketing-analytics', name: 'التسويق والتحليلات', url: '/catalog?category=marketing-analytics' },
      { id: 'education', name: 'التعليم والتدريب', url: '/catalog?category=education' }
    ]
  },

  // قوالب مواقع عامة (بدون تكرار أقسام الكتالوج مثل المتاجر/الحجوزات)
  {
    id: 'templates',
    name: 'قوالب',
    url: '/templates',
    hasDropdown: true,
    children: [
      { id: 'landing-pages', name: 'صفحات هبوط', url: '/catalog?category=landing-pages' },
      { id: 'portfolio', name: 'بورتفوليو وملفات شخصية', url: '/catalog?category=portfolio' },
      { id: 'blog-magazine', name: 'مدونات ومجلات', url: '/catalog?category=blog-magazine' },
      { id: 'saas-ui', name: 'واجهات SaaS ولوحات تحكم', url: '/catalog?category=saas-ui' }
    ]
  },

  // أنظمة ويب جاهزة (المشاريع الكبيرة والمدفوعة المحتملة)
  {
    id: 'web-systems',
    name: 'أنظمة',
    url: '/systems',
    hasDropdown: true,
    children: [
      { id: 'crm', name: 'إدارة العملاء (CRM)', url: '/catalog?category=crm' },
      { id: 'erp', name: 'إدارة الشركات (ERP)', url: '/catalog?category=erp' },
      { id: 'support-helpdesk', name: 'الدعم الفني ومكتب المساعدة', url: '/catalog?category=support-helpdesk' },
      { id: 'billing-finance', name: 'الفوترة والمحاسبة', url: '/catalog?category=billing-finance' }
    ]
  },

  // الذكاء الاصطناعي والوكلاء (تميّز المنصة)
  {
    id: 'ai',
    name: 'الوكلاء',
    url: '/ai',
    hasDropdown: true,
    children: [
      { id: 'ai-agents', name: 'وكلاء جاهزون للأعمال', url: '/catalog?category=ai-agents' },
      { id: 'ai-generators', name: 'مولدات المحتوى والنصوص', url: '/catalog?category=ai-generators' },
      { id: 'ai-integrations', name: 'تكاملات مع الأنظمة والمنصات', url: '/catalog?category=ai-integrations' }
    ]
  },

  // تطبيقات الهاتف
  {
    id: 'mobile-apps',
    name: 'تطبيقات',
    url: '/mobile',
    hasDropdown: true,
    children: [
      { id: 'ios', name: 'iOS', url: '/catalog?category=ios' },
      { id: 'android', name: 'Android', url: '/catalog?category=android' },
      { id: 'react-native', name: 'React Native', url: '/catalog?category=react-native' },
      { id: 'flutter', name: 'Flutter', url: '/catalog?category=flutter' }
    ]
  },

  // مكتبات الواجهة (للاانتشار وبناء المجتمع)
  {
    id: 'frontend-kits',
    name: 'مكتبات',
    url: '/frontend',
    hasDropdown: true,
    children: [
      { id: 'ui-components', name: 'مكونات UI', url: '/catalog?category=ui-components' },
      { id: 'animations', name: 'حزم الحركات والمؤثرات', url: '/catalog?category=animations' },
      { id: 'design-systems', name: 'أنظمة تصميم متكاملة', url: '/catalog?category=design-systems' }
    ]
  },

  // أصول رقمية (تخدم الهوية العربية وتغذي القوالب)
  {
    id: 'digital-assets',
    name: 'الأصول',
    url: '/assets',
    hasDropdown: true,
    children: [
      { id: 'icons', name: 'أيقونات', url: '/catalog?category=icons' },
      { id: 'illustrations', name: 'رسومات وإليستريشن', url: '/catalog?category=illustrations' },
      { id: 'videos', name: 'فيديوهات قصيرة', url: '/catalog?category=videos' },
      { id: 'audios', name: 'مؤثرات صوتية', url: '/catalog?category=audios' }
    ]
  }
];


